export interface UserDocument {
  id: string;
  user_id: string;
  tenant_id: string;
  document_name: string;
  document_type: string | null;
  storage_path: string;
  file_name: string;
  file_type: string | null;
  file_size_bytes: number | null;
  expires_at: string | null; // ISO date string (YYYY-MM-DD)
  notes: string | null;
  uploaded_by_user_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreateUserDocumentInput {
  user_id: string;
  document_name: string;
  document_type?: string;
  expires_at?: string | null;
  notes?: string;
  file: File;
}

export interface UpdateUserDocumentInput {
  document_name?: string;
  document_type?: string | null;
  expires_at?: string | null;
  notes?: string | null;
}

export type DocumentExpiryStatus = 'valid' | 'expiring_soon' | 'expired' | 'no_expiry';

export function getExpiryStatus(expiresAt: string | null): DocumentExpiryStatus {
  if (!expiresAt) return 'no_expiry';
  const now = new Date();
  const expiry = new Date(expiresAt);
  const daysUntilExpiry = Math.ceil((expiry.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

  if (daysUntilExpiry < 0) return 'expired';
  if (daysUntilExpiry <= 30) return 'expiring_soon';
  return 'valid';
}

export function getExpiryLabel(status: DocumentExpiryStatus, expiresAt: string | null): string {
  if (status === 'no_expiry') return 'No expiry';
  if (status === 'expired') return 'Expired';
  if (status === 'expiring_soon') {
    const days = Math.ceil((new Date(expiresAt!).getTime() - Date.now()) / (1000 * 60 * 60 * 24));
    return days <= 0 ? 'Expires today' : `Expires in ${days}d`;
  }
  return 'Valid';
}
